import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import './LinksNav.css';
import { useParams, Link as Anchor } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlus, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';

Modal.setAppElement('#root');

export default function LinksNav() {
    const LIMITE_INICIAL = 10;

    const [tienda, setTienda] = useState(null);
    const { idTienda } = useParams();
    const [categorias, setCategorias] = useState([]);
    const [tiendas, setTiendas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [categoriasProductos, setCategoriasProductos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalView, setModalView] = useState('tiendas');
    const [limiteProductos, setLimiteProductos] = useState(LIMITE_INICIAL);

    const toast = React.useRef(null);

    useEffect(() => {
        cargarTiendas();
        cargarCategoriaProductos();
        cargarCategoriaTienda();
    }, [idTienda]);

    const cargarTiendas = () => {
        fetch(`${baseURL}/tiendasFrontend.php`)
            .then(res => res.json())
            .then(data => {
                setTiendas(data.tiendas || []);
                const tienda = data.tiendas.find(t => t.idTienda === parseInt(idTienda));
                setTienda(tienda);
                setProductos(data.tiendas.flatMap(t => t?.productos) || []);
            })
            .catch(err => console.error(err));
    };

    const cargarCategoriaTienda = () => {
        fetch(`${baseURL}/categoriaTiendaGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []));
    };

    const cargarCategoriaProductos = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategoriasProductos(data?.categorias || []));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    /* =======================
       TIENDAS POR CATEGORÍA
    ======================= */
    const tiendasPorCategoria = categorias
        .map(categoria => ({
            ...categoria,
            tiendas: tiendas?.filter(t => t.idCategoria === categoria.idCategoria)
        }))
        .filter(c => c.tiendas.length > 0);

    /* =======================
       PRODUCTOS – LÍMITE GLOBAL
    ======================= */
    const productosVisibles = productos?.slice(0, limiteProductos);

    const productosPorCategoriaLimitados = categoriasProductos
        .map(categoria => ({
            ...categoria,
            productos: productosVisibles?.filter(
                producto => producto?.idCategoria === categoria?.idCategoria
            )
        }))
        .filter(c => c.productos?.length > 0);

    return (
        <div className="containerLinks">
            <Toast ref={toast} />

            {/* ===== TIENDAS DESKTOP ===== */}
            <div className="menu-item">
                Tiendas
                <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: '10px' }} />
                <div className="submenu">
                    {tiendasPorCategoria?.map(categoria => (
                        <div key={categoria?.idCategoria} className="categoria-container">
                            <h6>{categoria?.categoria}</h6>
                            <hr />
                            {categoria?.tiendas.map(tienda => (
                                <a
                                    key={tienda.idTienda}
                                    href={`/tienda/${tienda?.idTienda}/${tienda?.nombre?.replace(/\s+/g, '-')}`}
                                >
                                    <img src={obtenerImagen(tienda)} alt="" />
                                    {tienda.nombre}
                                </a>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {/* ===== PRODUCTOS DESKTOP ===== */}
            <div className="menu-item" style={{ marginTop: '20px' }}>
                Productos
                <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: '10px' }} />
                <div className="submenu">
                    {productosPorCategoriaLimitados?.map(categoria => (
                        <div key={categoria?.idCategoria} className="categoria-container">
                            <h6>{categoria?.categoria}</h6>
                            <hr />
                            {categoria?.productos?.map(producto => (
                                <Anchor
                                    key={producto?.idProducto}
                                    to={`/producto/${producto?.idProducto}/${producto?.titulo?.replace(/\s+/g, '-')}`}
                                >
                                    <img src={obtenerImagen(producto)} alt="" />
                                    {producto?.titulo}
                                </Anchor>
                            ))}
                        </div>
                    ))}

                    {productosVisibles?.length < productos?.length && (
                        <button
                            className="mostrar-mas-btn"
                            onClick={() => setLimiteProductos(prev => prev + 10)}
                        >
                            Mostrar más
                        </button>
                    )}
                </div>
            </div>

            {/* ===== BOTÓN MOBILE ===== */}
            <button className="toggle-button" onClick={() => setShowModal(true)}>
                <FontAwesomeIcon icon={faPlus} />
            </button>

            {/* ===== MODAL ===== */}
            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)}
                className="modalLinks"
                overlayClassName="overlayInput"
            >
                <div>
                    <div className="deFLex">
                        <button onClick={() => setShowModal(false)}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                    </div>

                    <div className="modal-flexButons">
                        <button
                            className={`modal-button ${modalView === 'tiendas' ? 'active' : ''}`}
                            onClick={() => setModalView('tiendas')}
                        >
                            Tiendas
                        </button>
                        <button
                            className={`modal-button ${modalView === 'productos' ? 'active' : ''}`}
                            onClick={() => setModalView('productos')}
                        >
                            Productos
                        </button>
                    </div>

                    {/* ===== TIENDAS MODAL ===== */}
                    {modalView === 'tiendas' && (
                        <div className="submenu">
                            {tiendasPorCategoria?.map(categoria => (
                                <div key={categoria?.idCategoria} className="categoria-container">
                                    <h6>{categoria?.categoria}</h6>
                                    <hr />
                                    {categoria?.tiendas?.map(tienda => (
                                        <a
                                            key={tienda?.idTienda}
                                            href={`/tienda/${tienda?.idTienda}/${tienda?.nombre?.replace(/\s+/g, '-')}`}
                                        >
                                            <img src={obtenerImagen(tienda)} alt="" />
                                            {tienda?.nombre}
                                        </a>
                                    ))}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* ===== PRODUCTOS MODAL ===== */}
                    {modalView === 'productos' && (
                        <div className="submenu">
                            {productosPorCategoriaLimitados?.map(categoria => (
                                <div key={categoria?.idCategoria} className="categoria-container">
                                    <h6>{categoria?.categoria}</h6>
                                    <hr />
                                    {categoria?.productos?.map(producto => (
                                        <Anchor
                                            key={producto?.idProducto}
                                            to={`/producto/${producto?.idProducto}/${producto?.titulo.replace(/\s+/g, '-')}`}
                                        >
                                            <img src={obtenerImagen(producto)} alt="" />
                                            {producto?.titulo}
                                        </Anchor>
                                    ))}
                                </div>
                            ))}

                            {productosVisibles?.length < productos?.length && (
                                <button
                                    className="mostrar-mas-btn"
                                    onClick={() => setLimiteProductos(prev => prev + 10)}
                                >
                                    Mostrar más
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
}
